import * as ACTION from '../constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function* () {
	yield takeLatest(ACTION.CREATE_WAREHOUSE.REQUEST, saga.createWarehouse);
	yield takeLatest(ACTION.CREATE_WAREHOUSE.SUCCESS, saga.createWarehouseSuccess);
}
